import { PayloadAction } from '@reduxjs/toolkit';
import { CategoryState, FilterAttributeGroup } from 'store/category/types';

export interface UpdateFilterAttributeOptionPyload {
  typeName: string;
  value: string;
  group: FilterAttributeGroup;
}

const updateFilterAttributeOptionReducer = (
  state: CategoryState,
  action: PayloadAction<UpdateFilterAttributeOptionPyload>,
) => {
  const filtersGroup = action.payload.group;
  const targetAttribute = state.filters?.[filtersGroup]?.find(
    (attribute) => attribute.typeName === action.payload.typeName,
  );
  if (!targetAttribute) {
    return;
  }
  const tartgetOption = targetAttribute.options?.find((option) => option.value === action.payload.value);
  if (!tartgetOption) {
    return;
  }
  tartgetOption.isSelected = !tartgetOption.isSelected;
};

export default updateFilterAttributeOptionReducer;
